module.exports = ".my-expansion {\n  margin-top: 1em !important; }\n\n.RoundedBtn {\n  border-radius: 4px; }\n"